<template>
	<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="100%"
            class="boxdop2"
			:before-close="handleClose">
			<div class="dialog-table">
                <comTable @selectedDatafn="selectedDatafn" :config="tableConfig" :filterForm="filterForm" ref="table">
                </comTable>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="savePopFn" v-text="`确定 (${selectedData.length || 0})`"></el-button>
			</span>
		</el-dialog>
  
</template>
<script>
import comTable from '@/components/firTable.vue'
export default {
    components: {comTable},
	props:{
		config:Object,
		listids:Array
	},
    data() {
        return {
            selectedData:[],
            dialogVisible:true,
            filterForm: [
				{prop: 'id', label: '内容ID', pl: '请输入内容ID检索'},
				{prop: 'title', label: '内容标题', pl: '请输入内容标题检索'},
				{prop: 'author', label: '创作者昵称', pl: '请输入创作者昵称检索'},
				{prop: 'tag', label: '标签', pl: '请输入标签检索'}
			],
            
            jump_type:{
				'1':'专题列表',
				'2':'大图',
				'3':'视频',
				'4':'文章',
				'5':'链接'
			},
            tableConfig:{
				pr:{status:'0,1'},
                isSelection:true,
				url:'getContentList',
				list:[
					{label:'当前专题选中状态',clfn:row=>{
						return this.listids.indexOf(row.id)==-1?'未选中':'已选中'
					}},
					{label:'内容ID',prop:'id'},
					{label:'展示图',prop:'prev_url',type:'img',clfn:da=>{
						let da_obj = JSON.parse(JSON.stringify(da))
						if(da_obj.prev_url.indexOf("x-oss-process")!=-1){
							var ad = da_obj.prev_url.split('?')
							da.prev_url = ad[0]
						}

						return da.prev_url?`${da.prev_url}?x-oss-process=image/resize,h_80`:''
					}},
					{label:'标题',prop:'title'},
					{label:'副标题',prop:'sub_title'},
                    {label:'跳转类型',prop:'jump_type',clfn:da=>{
						return this.jump_type[da.jump_type] || ''
					}},
					{label:'跳转内容',prop:'jump_to',type:'html',clfn:da=>{
						if(da.jump_type==2){
							return `<img class="tableImg" src="${da.jump_to}">`
						}
						if(da.jump_type==3){
							return `<video class="tableImg" src="${da.jump_to}"></video>`
						}
						return da.jump_to
					}},
					


               
                    {label:'创作者昵称',prop:'author'},
					{label:'标签',prop:'tags',type:'html',clfn:da=>{
						let arr = [];
						try {
							arr = JSON.parse(da.tags);
						} catch (error) {
							console.log()
						}
						let str = '';
						arr.map(e=>{
							str+=`<span class="tages">${e}</span>`
						})
						return str;
					}},
				
					{label:'创建时间',prop:'create_at'},
					// {label:'操作',type:'tool',btns:[
					// 	{label:'查看',clickFn:da=>{
					// 		this.lookBtn(da,'look')
					// 	}},

					// ]},
				]
			},
        }
    },
	created(){
		if(this.config.pr){
			this.tableConfig.pr = Object.assign(this.tableConfig.pr,this.config.pr)
		}
	},
    methods: {
		lookBtn () {
			this.$message('look')
		},
        selectedDatafn(da){
            this.selectedData = da;
        },
        savePopFn () {
            this.$emit('sucss',this.selectedData)
		},
        handleClose(){
            this.$emit('close')
        }
    },
};
</script>
<style lang='scss'>
.boxdop2{
    height: 100vh;
}
.boxdop2 .el-dialog__body{
    height: calc(100vh - 60px);
}
.boxdop2 .dialog-table{
    height: 100%;
}
.boxdop2 .el-dialog__footer{
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
}
</style>